import { useSearchParams } from 'react-router-dom';

import { parseQueryString } from '@toss/utils';
import { z } from 'zod';

import { useBoolean } from '@looko-corp/acloset-react-kit/src/react';

import { useScreenType } from '@/hook/useMobileView';

import { 모바일_유도_모달 } from './모바일_유도_모달';

const 모바일_유도_스키마 = z.object({
  /**
   * - true: 데스크톱, 앱설치 유도 모달 미노출(ex. 초대토큰으로 대시보드에 진입할 경우)
   * - false: 데스크톱, 앱설치 유도 모달 노출
   */
  isIgnoreMobileRedirect: z.enum(['true', 'false']).transform(value => value === 'true'),
});

/**
 * 모바일 화면에서 데스크톱, 앱설치로 유도하는 컴포넌트
 * (웹뷰에서는 노출하지 않음)
 */
export const MobileRedirect = ({ children }: { children: React.ReactNode }) => {
  const [searchParams] = useSearchParams();

  const queryObject = parseQueryString(location.search);

  const screenType = useScreenType();

  const { value: isOpen, setFalse: onClose } = useBoolean(true);

  const safeParsedData = 모바일_유도_스키마.safeParse(queryObject);

  const isIgnoreMobileRedirect = safeParsedData.success
    ? safeParsedData.data.isIgnoreMobileRedirect
    : (searchParams.get('isIgnoreMobileRedirect') ?? 'false') === 'true';

  if (isOpen && screenType === 'mobile' && !isIgnoreMobileRedirect && window.ReactNativeWebView == null) {
    return <모바일_유도_모달 onClose={onClose} />;
  } else {
    return children;
  }
};
